<template lang="pug">
el-form(:model='novoUsuario')
    el-form-item
        .label(slot='label')
            span {{ $t('mensagens.usuarios.tabela.nome') }}
            span.erro(v-if='$v.novoUsuario.nome.$invalid') *
        el-input(v-model='novoUsuario.nome')

    el-form-item
        .label(slot='label')
            span {{ $t('mensagens.usuarios.tabela.email.label') }}
            span.erro(v-if='$v.novoUsuario.email.$invalid') *
        el-input(v-model='novoUsuario.email')

    el-form-item
        .label(slot='label')
            span {{ $t('mensagens.usuarios.empresa') }}
            span.erro(v-if='$v.novoUsuario.idEmpresa.$invalid') *
        el-select(
            v-model='novoUsuario.idEmpresa',
            :placeholder='$t("mensagens.usuarios.modalUsuario.buscaPorNome")',
            filterable,
            remote,
            reserve-keyword,
            :remote-method='remoteMethod'
        )
            el-option(
                v-for='empresa in empresas',
                :key='"empresa" + empresa.id',
                :label='empresa.name',
                :value='empresa.id'
            )

    el-form-item
        .label(slot='label')
            span {{ $t('mensagens.usuarios.modalUsuario.perfil') }}
        el-select(
            v-model='roleSelecionada',
            :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
            value-key='id',
            clearable
        )
            el-option(
                v-for='role in rolesOperacao',
                :key='"role" + role.id',
                :label='getRoleTraduzido(role)',
                :value='role'
            )

    el-form-item(v-if='deveExibirCampo()')
        .label(slot='label')
            span {{ $t('mensagens.comuns.tipo') }}
        el-select(
            v-model='novoUsuario.perfil',
            :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
            clearable,
            @change='getUserNameById'
        )
            el-option(
                v-for='gerentes in gerente',
                :key='gerentes.id',
                :label='gerentes.nome',
                :value='gerentes.id'
            )

    el-form-item(v-if='deveExibirCampo()')
        .label(slot='label')
            span {{ $t('mensagens.usuarios.pessoaEstruturaComercial') }}
        el-select(
            v-model='novoUsuarioGestor.idPessoa',
            :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
            clearable
        )
            el-option(
                v-for='usuarioRoles in usuarioRole',
                :key='usuarioRoles.id',
                :label='usuarioRoles.idPessoa.nome',
                :value='usuarioRoles.idPessoa.id'
            )

    el-form-item(v-if='deveExibirCampoAssistente()')
        .label(slot='label')
            span {{ $t('mensagens.usuarios.assistenteGestor') }}
        el-select(
            v-model='novoUsuario.perfil',
            :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
            clearable,
            @change='getUserNameById'
        )
            el-option(
                v-for='gerentes in gerente',
                :key='gerentes.id',
                :label='gerentes.nome',
                :value='gerentes.id'
            )

    el-form-item(v-if='deveExibirCampoAssistente()')
        .label(slot='label')
            span {{ $t('mensagens.usuarios.pessoaEstruturaComercial') }}
        el-select(
            v-model='novoUsuarioGestor.idPessoa',
            :placeholder='$t("mensagens.usuarios.modalUsuario.selecionar")',
            clearable
        )
            el-option(
                v-for='usuariosRole in usuarioRole',
                :key='usuariosRole.id',
                :label='usuariosRole.idPessoa.nome',
                :value='usuariosRole.idPessoa.id'
            )
</template>
<script>
export default {
    props: {
        empresas: {
            type: Array,
            default: () => []
        },
        gerentes: {
            type: Array,
            default: () => []
        },
        rules: {
            type: Array,
            default: () => []
        },
        operacoes: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            novoUsuario: {
                nome: '',
                email: '',
                administrador: false,
                idEmpresa: '',
                idRole: ''
            },
            roleSelecionada: ''
        };
    },
    methods: {
        deveExibirCampo() {
            return this.roleSelecionada.name === 'GESTOR';
        },

        deveExibirCampoEditar() {
            return this.roleSelecionada.name === 'GESTOR';
        },

        deveExibirCampoAssistente() {
            return this.roleSelecionada.name === 'ASSISTENTE';
        },

        deveExibirCampoEditarAssistente() {
            return this.roleSelecionada.name === 'ASSISTENTE';
        }
    }
};
</script>
